import React from 'react';
import { omit } from 'lodash';
import { BaseFieldProps, Field, WrappedFieldProps } from 'redux-form';
import { FieldValues, UseControllerProps, useController } from 'react-hook-form';

import { DateTimePickerInput, DateTimePickerInputOwnProps } from './datetime-input';

/**
 * By default the form validation mode is set to `mode: 'onSubmit'`.
 * This means the validation will be shown after submitting the form.
 * You probably want to set this option to `all` to have immediate feedback when a field does not pass the added rules.
 * useForm({ mode: 'all' });
 */
export function DateTimeInputHookForm<T extends FieldValues>(
  props: Omit<DateTimePickerInputOwnProps, 'onChange'> & UseControllerProps<T>,
) {
  const { field } = useController(props);
  return (
    <DateTimePickerInput
      {...props}
      {...field}
    />
  );
}

const ReduxFormField = (props: WrappedFieldProps & DateTimePickerInputOwnProps) => (
  <DateTimePickerInput
    {...props.input}
    {...omit(props, ['meta', 'input'])}
  />
);

export default ({ name, ...props }: BaseFieldProps) => (
  <Field
    name={name}
    props={props}
    component={ReduxFormField}
  />
);
